<template>
  <admin-wrapper :straight-title="additionalModuleName" :module-enabler="moduleEnabler" :inputs="inputs" />
</template>

<script>
import { get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';

export default {
  name: 'PrintsTwoSettings',
  components: { AdminWrapper },
  computed: {
    additionalModuleName: get('admin/additionalModules@PRINTING_2_MODULE.verbose_name'),
    coordinatesEpsgs: get('map/coordinatesEpsgs'),
    coordinatesEpsgsArray() {
      return Object.keys(this.coordinatesEpsgs)
        .reduce((total, current) => {
          return [...total, { text: current, value: this.coordinatesEpsgs[current].srid }];
        }, [])
        .filter(epsg => epsg.value !== 4326);
    },
    moduleEnabler() {
      return {
        name: 'printing_2_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
    inputs() {
      return [
        {
          name: 'printing_2_srid',
          translationPath: 'admin.printingCoordinateSystem',
          dataType: { name: 'select' },
          items: this.coordinatesEpsgsArray,
          rules: [v => !!v || v == '0' || 'rules.required'],
          align: 'start',
        },
        {
          name: 'printing_footer',
          translationPath: 'admin.printingFooter',
          subtitle: 'admin.printingFooterSubtitle',
          dataType: { name: 'textarea' },
          align: 'start',
          rows: '4',
          noResize: true,
        },
      ];
    },
  },
};
</script>
